export const environment = {
  production: false,
  apiUrl: 'https://dev-agt-api.uims.kz/api/',
};
